// Configure PILLAR API with frontend-specific session handling
import { createPillarApi } from '@pillar-portal/api-types';
import { handleSessionExpired } from './sessionManager';
import { setTraceContextHeader } from './logging/frontend-logger';

const pillarApi = createPillarApi(handleSessionExpired, '/api', setTraceContextHeader);

export const {
    authApi,
    userApi,
    organizationApi,
    customerApi,
    paymentsInfrastructureApi,
    sambaApi,
    sambaConfigApi,
    diagnosticsApi,
    encryptionKeysApi,
    secretsApi,
    rpaCredentialInjectionApi,
    ipxCredentialManagementApi,
    permissionsApi,
    authorizationApi,
    legalDocumentsApi,
    auditApi,
    appApi,
    paymentsApi,
    allowedWebsiteTemplatesApi,
} = pillarApi;

// Re-export ApiError for backward compatibility
export { ApiError } from '@pillar-portal/api-types';
